module.exports = __webpack_public_path__ + "static/line-marble-76c65cb4121539fba80e73942e26cc0d.svg";